import { Controller } from "stimulus";

export default class extends Controller {
  connect() {}

  skip(event) {
    window.location.href="#main";   
    history.pushState('', document.title, window.location.pathname);
    window.scrollTo(-1,-1);
  }
}
